import React from 'react';

export const NetworkErrorIcon: React.FC = () => (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Signal arcs */}
        <path d="M8 28 C8 16 16 8 28 8 C40 8 48 16 48 28" stroke="#e5e7eb" strokeWidth="3" strokeLinecap="round" fill="none" />
        <path d="M14 34 C14 24 20 18 28 18 C36 18 42 24 42 34" stroke="#e5e7eb" strokeWidth="3" strokeLinecap="round" fill="none" />
        <path d="M20 40 C20 34 23 30 28 30 C33 30 36 34 36 40" stroke="#e5e7eb" strokeWidth="3" strokeLinecap="round" fill="none" />
        {/* Slash overlay */}
        <line x1="12" y1="12" x2="44" y2="44" stroke="#dc2626" strokeWidth="3.5" strokeLinecap="round" />
        {/* Dot */}
        <circle cx="28" cy="47" r="3" fill="#9ca3af" />
    </svg>
);
